module.exports = __webpack_public_path__ + "img/close.000f88a4.svg";